import React from 'react'

const HomeVerticalSmallMobile = () => {
  return (
    <div className="home-vertical-small-mobile">
      <div className="column1"/>
      <div className="column2"/>
    </div>
  )
}

export default  HomeVerticalSmallMobile




// WEBPACK FOOTER //
// ./src/HomeVerticalSmallMobile.js